/**
 * Moves an item in the array from one index to another index.
 */
export function moveArrayItem<T>(array: T[], fromIndex: number, toIndex: number): T[] {
  const length = array.length;

  if (length === 0 || fromIndex === toIndex || fromIndex < 0 || fromIndex >= length) {
    return array;
  }

  if (toIndex >= length) {
    toIndex = length - 1;
  } else if (toIndex < 0) {
    toIndex = 0;
  }

  array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);

  return array;
}
